/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Video_UrlInputs */

const en_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Video URL`)
};

const es_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de video privado`)
};

const fr_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de la vidéo privée`)
};

const de_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Video-URL`)
};

const ja_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライベートビデオURL`)
};

const zh_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私有视频 URL`)
};

const ar_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رابط فيديو خاص`)
};

const id_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL Video Pribadi`)
};

const it_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL del Video Privato`)
};

const ru_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-адрес частного видео`)
};

const pt_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de Vídeo Privado`)
};

const ko_private_video_url = /** @type {(inputs: Private_Video_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비공개 비디오 URL`)
};

/**
* | output |
* | --- |
* | "Private Video URL" |
*
* @param {Private_Video_UrlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const private_video_url = /** @type {((inputs?: Private_Video_UrlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Video_UrlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_private_video_url(inputs)
	if (locale === "es") return es_private_video_url(inputs)
	if (locale === "fr") return fr_private_video_url(inputs)
	if (locale === "de") return de_private_video_url(inputs)
	if (locale === "ja") return ja_private_video_url(inputs)
	if (locale === "zh") return zh_private_video_url(inputs)
	if (locale === "ar") return ar_private_video_url(inputs)
	if (locale === "id") return id_private_video_url(inputs)
	if (locale === "it") return it_private_video_url(inputs)
	if (locale === "ru") return ru_private_video_url(inputs)
	if (locale === "pt") return pt_private_video_url(inputs)
	return ko_private_video_url(inputs)
});